import React from  "react";


const Confirmation: React.FC = () => {
  return <p>Confirmation</p>
};

export default Confirmation;
